import { render, staticRenderFns } from "./BlockType23SmallRow.vue?vue&type=template&id=07cd1667&scoped=true"
import script from "./BlockType23SmallRow.vue?vue&type=script&lang=ts"
export * from "./BlockType23SmallRow.vue?vue&type=script&lang=ts"
import style0 from "./BlockType23SmallRow.vue?vue&type=style&index=0&id=07cd1667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd1667",
  null
  
)

export default component.exports